export default {
  CircleRipple: require('./circle-ripple'),
  FocusRipple: require('./focus-ripple'),
  TouchRipple: require('./touch-ripple'),
};



/** WEBPACK FOOTER **
 ** ../src/ripples/index.js
 **/